export const isHybrid888 = () =>
  navigator.userAgent.includes('5eaaadc3-3145-4490-a4d8-db9bdf9d4182');
